__turbopack_context__.v({
  "ads": "ads-module__6Q5IkG__ads",
  "ads_placeholder": "ads-module__6Q5IkG__ads_placeholder",
  "img": "ads-module__6Q5IkG__img",
  "lg": "ads-module__6Q5IkG__lg",
  "md": "ads-module__6Q5IkG__md",
  "path_1": "ads-module__6Q5IkG__path_1",
  "path_2": "ads-module__6Q5IkG__path_2",
  "xlg": "ads-module__6Q5IkG__xlg",
});
